import CardSection from "../../formatting/CardSection";
import { StandardPackageDetails } from "./StandardCard";
import { SimplePackageDetails } from "./SimpleCard";
import ComparisonTable from "./ComparisonTable";
import { Accordion } from "@teamscheme/accordion";
import styled from "styled-components";
import { PremiumPackageDetails } from "./PremiumCard";
import { HTMLAttributes } from "react";

export const TopSection = styled(CardSection)`
  margin-bottom: ${({ theme }) => theme.spacing.space32};
`;

export interface PackageInformationProps
  extends Omit<HTMLAttributes<HTMLDivElement>, "children"> {
  simple?: boolean;
  standard?: boolean;
  complete?: boolean;
}

const PackageInformation = styled(function ({
  simple,
  standard,
  complete,
  ...props
}: PackageInformationProps) {
  return (
    <div {...props}>
      <TopSection>
        <h2>Sammenlign våre oppgraderinger</h2>
        <ComparisonTable />
      </TopSection>
      <CardSection>
        <Accordion>
          <h2>Informasjon om pakkene</h2>
          {complete && (
            <Accordion.Row id="#info-trygt-eierskifte" title="Premium">
              <PremiumPackageDetails />
            </Accordion.Row>
          )}
          {standard && (
            <Accordion.Row id="info-standard" title="Standard">
              <StandardPackageDetails />
            </Accordion.Row>
          )}
          {simple && (
            <Accordion.Row id="#info-enkel" title="Enkel">
              <SimplePackageDetails />
            </Accordion.Row>
          )}
        </Accordion>
      </CardSection>
    </div>
  );
})``;

export default PackageInformation;
